import React from 'react'
import { Button, Box, alpha, styled } from '@mui/material'
import { UserIcon } from '../../../../components/Icons'
import { useSidebarContext } from '../../../../contexts/Old_SidebarContext'
import { UpgradeSubscriptionDialog } from '../../../../components/shared/Dialogs'
import { maxHeaderSize } from 'http'

const StyledButton = styled(Button)(({ theme }) => ({
  position: 'fixed',
  left: '0px',
  right: '0px',
  bottom: '1px',
  maxWidth: '315px',
  color: theme.palette.secondary.main,
  background: alpha(theme.palette.primary.main, 0.9),
  border: '1px solid',
  borderColor: alpha(theme.palette.primary.main, 0.9),
  '&:hover': {
    background: alpha(theme.palette.primary.main, 1),
    borderColor: theme.palette.primary.main,
  },
}))

const UpgradeSubscription = () => {
  const { upgradeSubscriptionDialog, setUpgradeSubscriptionDialog } = useSidebarContext()
  const ExpiryDate = sessionStorage.getItem('ExpiryDate')
  const handleClick = () => {
    setUpgradeSubscriptionDialog(true)
  }

  const handleClose = () => {
    setUpgradeSubscriptionDialog(false)
  }

  let timeDiff = 0
  if (ExpiryDate) {
    const expiryDate = new Date(ExpiryDate)
    const currentDate = new Date()
    timeDiff = expiryDate.getTime() - currentDate.getTime()
  }

  // Calculate the number of days remaining
  const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))

  return (
    <Box
      style={{
        border: '2px solid gray',
        borderRadius: '8px',
        padding: '5px',
        backgroundColor: '#f0f0f0',
        display: 'flex',
        position: 'fixed',
        left: '0px',
        right: '0px',
        bottom: '1px',
        maxWidth: '325px',
        gap: '10px',
        maxHeight: '55px',
      }}
    >
      <Button
        sx={{
          fontSize: '14px',
          fontWeight: 'bold',
          lineHeight: '12px',
          bgcolor: daysRemaining > 10 ? 'white' : daysRemaining > 0 ? 'red' : '#e43131',
          color: daysRemaining > 10 ? 'green' : daysRemaining > 0 ? 'white' : '#f9f9f7',
          '&:hover': {
            bgcolor: daysRemaining > 10 ? 'white' : daysRemaining > 0 ? 'red' : '#e43131',
            color: daysRemaining > 10 ? 'green' : daysRemaining > 0 ? 'white' : '#fcf922',
          },
        }}
      >
        {daysRemaining > 0 ? `${daysRemaining} day(s) left` : 'Subscription Expired'}
      </Button>

      <Button
        sx={{
          bgcolor: '#fbd439',
          color: '#777',
          '&:hover': { bgcolor: '#297c29ff', color: '#fffffdff' },
        }}
        startIcon={<UserIcon sx={{ width: 24, height: 24 }} />}
        onClick={handleClick}
      >
        Upgrade
      </Button>

      <UpgradeSubscriptionDialog />
    </Box>
  )
}

export default UpgradeSubscription
